import { Box, Skeleton } from "@mui/material";

const LoadingSkeleton: React.FC = () => {
  const skeletonRows = [
    "skeleton-row-1",
    "skeleton-row-2",
    "skeleton-row-3",
    "skeleton-row-4",
    "skeleton-row-5",
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Box className="grid grid-cols-2 gap-4 items-stretch mb-4">
        <Skeleton variant="rectangular" height={40} />
        <Box className="w-full flex justify-end">
          <Skeleton variant="rectangular" width={120} height={40} />
        </Box>
      </Box>
      <Box>
        {skeletonRows.map((key) => (
          <Box key={key} className="flex items-center space-x-4 py-4">
            <Skeleton variant="rectangular" width={120} height={20} />
            <Skeleton variant="rectangular" width={200} height={20} />
            <Skeleton variant="rectangular" width={150} height={20} />
            <Skeleton variant="rectangular" width={100} height={20} />
            <Skeleton variant="rectangular" width={80} height={20} />
            <Skeleton variant="rectangular" width={100} height={20} />
            <Skeleton variant="rectangular" width={120} height={20} />
            <Skeleton variant="rectangular" width={100} height={20} />
            <Skeleton variant="rectangular" width={80} height={20} />
            <Skeleton variant="rectangular" width={100} height={20} />
            <Skeleton variant="rectangular" width={40} height={20} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LoadingSkeleton;
